import React from 'react';
import { useIntl } from 'react-intl';
import OffsiteConstrutionImg from '../images/offsite-construction.png';
import css from './Sections.module.css';

function SectionsOffsiteConstruction() {
  const intl = useIntl();

  return (
    <div className={css.offsiteConstrution}>
      <div className={css.contentWidth}>
        <h2>{intl.formatMessage({ id: 'SectionsOffsiteConstruction.title' })}</h2>
        <p>
          {intl.formatMessage({
            id: 'SectionsOffsiteConstruction.description',
          })}
        </p>
        <img src={OffsiteConstrutionImg} alt="" />
      </div>
    </div>
  );
}

export default SectionsOffsiteConstruction;
